import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Flex.scss';

export function FlexColumn({
	as: Component = 'div',
	children,
	className,
	gapSmall = false,
	alignCenter = false,
	...props
}) {
	return (
		<Component
			className={classnames(
				'flex-column',
				{
					'gap-small': gapSmall,
					'align-center': alignCenter,
				},
				className,
			)}
			{...props}
		>
			{children}
		</Component>
	);
}

FlexColumn.propTypes = {
	as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	children: PropTypes.node,
	className: PropTypes.string,
	gapSmall: PropTypes.bool,
	alignCenter: PropTypes.bool,
};
